<template>
  <div id="home-page">
    <div class="home">
      <div class="home-top">
        <div class="home-top-menu home-top-time flex-content-center font-bold">{{nowTime}}</div>
        <div class="home-top-title font-bold" @click="jump('/keypersonnel')">召陵区综治中心智慧平台</div>
        <div class="home-top-menu home-top-weather flex-content-center weather">
            <!-- <img class="mr-10" style="width:133px;" src="@/assets/image/jump-bg.png" draggable="false"> -->
            <img class="mr-22" v-if="weather_image" style="width:30px;" :src="weather_image" alt="" draggable="false">
            <img class="mr-10"  src="@/assets/image/wendu.png" alt="" draggable="false">
            <span>{{wendu}}℃</span>
            <img @click="toggleFullScreen" class="ml-50 hover" src="@/assets/image/full-screen.png" alt="" draggable="false">
        </div>
      </div>
      <div class="home-body">
        <div class="home-body-left">
          <div class="home-body-left-top flex-evenly-center text-center">
            <div class="item">
              <div class="p1 pb-6 font-bold">累计接待</div>
              <div class="p2 pl-10">
                <span class="num color1 mr-8 font-bold">{{total.receive_num || 0}}</span><span class="font-15">人</span>
              </div>
            </div>
            <div class="item">
              <div class="p1 pb-6 font-bold">今日接待</div>
              <div class="p2 pl-10">
                <span class="num color2 mr-8 font-bold">{{today.receive_num || 0}}</span><span class="font-15">人</span>
              </div>
            </div>
          </div>
          <!-- 全域态势感知 -->
          <div class="home-body-left-one home-box">
            <div class="home-box-title flex-between-center">
              <div class="flex-center">
                <img src="@/assets/image/arrow1.png" alt="" draggable="false">
                <span class="text font-bold">全域态势感知</span>
              </div>
              <div class="flex-center">
                <img class="hover" src="@/assets/image/menu.png" alt="" draggable="false">
              </div>
            </div>
            <div class="home-box-content">
              <QuanyuChart :dataList="chart_quanyu"></QuanyuChart>
            </div>
          </div>
          <!-- 群众意见箱 -->
          <div class="home-body-left-two home-box mt-14">
            <div class="home-box-title flex-between-center">
              <div class="flex-center">
                <img src="@/assets/image/arrow1.png" alt="" draggable="false">
                <span class="text font-bold">群众意见箱</span>
              </div>
              <div class="flex-center">
                <img class="hover" src="@/assets/image/menu.png" alt="" draggable="false">
              </div>
            </div>
            <div class="home-box-content">
              <div class="notice">
                  <div class="notice-item notice-head">
                      <div class="notice-class w25">姓名</div>
                      <div class="notice-class w45">留言内容</div>
                      <div class="notice-class w30">时间</div>
                  </div>
                  <vue-seamless-scroll :data="feedback_list" :class-option="classOption" class="seamless-warp">
                      <div class="notice-item" v-for="(item,index) in feedback_list" :key="index">
                          <div class="notice-class w25" v-if="item.visitor && item.visitor.name">{{item.visitor.name.slice(0, 1)}}**</div>
                          <div class="notice-class w25" v-else>-</div>
                          <div class="notice-class w45">{{item.content}}</div>
                          <div class="notice-class w30">{{item.create_time.slice(0, 10)}}</div>
                      </div>
                  </vue-seamless-scroll>
              </div>
            </div>
          </div>
          <!-- 来访趋势分析 -->
          <div class="home-body-left-three home-box mt-14">
            <div class="home-box-title flex-between-center">
              <div class="flex-center">
                <img src="@/assets/image/arrow1.png" alt="" draggable="false">
                <span class="text font-bold">来访趋势分析</span>
              </div>
              <div class="flex-center">
                <img class="hover" src="@/assets/image/menu.png" alt="" draggable="false">
              </div>
            </div>
            <div class="home-box-content">
              <LaifangChart :dataList="chart_laifang"></LaifangChart>
            </div>
          </div>
        </div>
        <div class="home-body-center">
          <div class="home-body-center-top flex-between-center text-left pl-5 pr-5">
            <div class="item flex-center">
              <img src="@/assets/image/data-1.png" alt="" draggable="false">
              <div class="pl-18">
                <div class="num">{{total.settled_dept_num || 0}}</div>
                <div class="font-15">已入驻单位</div>
              </div>
            </div>
            <div class="item flex-center">
              <img src="@/assets/image/data-2.png" alt="" draggable="false">
              <div class="pl-18">
                <div class="num">{{total.settled_staff_num || 0}}</div>
                <div class="font-15">已入驻人员</div>
              </div>
            </div>
            <div class="item flex-center">
              <img src="@/assets/image/data-3.png" alt="" draggable="false">
              <div class="pl-18">
                <div class="num">{{today.settled_dept_num || 0}}</div>
                <div class="font-15">今日开放窗口</div>
              </div>
            </div>
            <div class="item flex-center">
              <img src="@/assets/image/data-4.png" alt="" draggable="false">
              <div class="pl-18">
                <div class="num">{{today.settled_staff_num || 0}}</div>
                <div class="font-15">今日到岗人员</div>
              </div>
            </div>
          </div>
          <!-- 大厅工作窗口状态 -->
          <div class="home-body-center-one home-box">
            <div class="home-box-title home-box-title-2 flex-between-center">
              <div class="flex-center">
                <img src="@/assets/image/arrow1.png" alt="" draggable="false">
                <span class="text font-bold">大厅工作窗口状态</span>
              </div>
              <div class="flex-center">
                <img class="hover" src="@/assets/image/menu.png" alt="" draggable="false">
              </div>
            </div>
            <div class="home-box-content">
              <div class="nav">
                <vue-seamless-scroll :data="dept_list" :class-option="classOption2" class="seamless-warp">
                  <div class="flex-center">
                    <div class="item flex-content-center" v-for="(item,index) in dept_list" :key="index"><span class="font-bold">{{ item }}</span></div>
                  </div>
                </vue-seamless-scroll>
                <!-- <div class="item flex-content-center" v-for="(item, index) in dept_list" :key="index"><span>{{ item }}</span></div> -->
              </div>
              <div class="content">
                <img style="width: 100%;" src="@/assets/center.png" alt="" draggable="false">
              </div> 
            </div>
          </div>
          <!-- 分中心受理情况 -->
          <div class="home-body-center-two home-box mt-16">
            <div class="home-box-title home-box-title-2 flex-between-center">
              <div class="flex-center">
                <img src="@/assets/image/arrow1.png" alt="" draggable="false">
                <span class="text font-bold">分中心受理情况</span>
              </div>
              <div class="flex-center">
                <img class="hover" src="@/assets/image/menu.png" alt="" draggable="false">
              </div>
            </div>
            <div class="home-box-content">
              <ShouliChart :dataList="chart_shouli"></ShouliChart>
            </div>
          </div>
        </div>
        <div class="home-body-right">
          <div class="home-body-right-top flex-evenly-center text-center">
            <div class="item">
              <div class="p1 pb-6 font-bold">累计受理</div>
              <div class="p2 pl-10">
                <span class="num color3 mr-8 font-bold">{{total.accept_num || 0}}</span><span class="font-15">人</span>
              </div>
            </div>
            <div class="item">
              <div class="p1 pb-6 font-bold">今日受理</div>
              <div class="p2 pl-10">
                <span class="num color4 mr-8 font-bold">{{today.accept_num || 0}}</span><span class="font-15">人</span>
              </div>
            </div>
          </div>
          <!-- 窗口挂号 -->
          <div class="home-body-right-one home-box">
            <div class="home-box-title flex-between-center">
              <div class="flex-center">
                <img src="@/assets/image/arrow1.png" alt="" draggable="false">
                <span class="text font-bold">窗口挂号</span>
              </div>
              <div class="flex-center">
                <img class="hover" src="@/assets/image/menu.png" alt="" draggable="false">
              </div>
            </div>
            <div class="home-box-content">
              <div class="notice">
                  <div class="notice-item notice-head">
                      <div class="notice-class w25">窗口</div>
                      <div class="notice-class w25">诉求内容</div>
                      <div class="notice-class w30">编号</div>
                      <div class="notice-class w20">状态</div>
                  </div>
                  <vue-seamless-scroll :data="visitor_list" :class-option="classOption" class="seamless-warp">
                      <div class="notice-item" v-for="(item,index) in visitor_list" :key="index">
                          <div class="notice-class w25" v-if="item.dep && item.dep.name">{{item.dep.name}}</div>
                          <div class="notice-class w25" v-else>-</div>
                          <div class="notice-class w25">{{item.matter}}</div>
                          <div class="notice-class w30">{{item.no}}</div>
                          <div class="notice-class w20">{{item.status_text}}</div>
                      </div>
                  </vue-seamless-scroll>
              </div>
            </div>
          </div>
          <!-- 中心会诊 -->
          <div class="home-body-right-two home-box mt-14">
            <div class="home-box-title flex-between-center">
              <div class="flex-center">
                <img src="@/assets/image/arrow1.png" alt="" draggable="false">
                <span class="text font-bold">中心会诊</span>
              </div>
              <div class="flex-center">
                <img class="hover" src="@/assets/image/menu.png" alt="" draggable="false">
              </div>
            </div>
            <div class="home-box-content">
              <div class="notice">
                  <div class="notice-item notice-head">
                      <div class="notice-class w30">编号</div>
                      <div class="notice-class w50">问题描述</div>
                      <div class="notice-class w20">状态</div>
                  </div>
                  <vue-seamless-scroll :data="visitor_joint_list" :class-option="classOption" class="seamless-warp">
                      <div class="notice-item" v-for="(item,index) in visitor_joint_list" :key="index">
                          <div class="notice-class w30">{{item.no}}</div>
                          <div class="notice-class w50">{{item.matter}}</div>
                          <div class="notice-class w20">{{item.status_text}}</div>
                      </div>
                  </vue-seamless-scroll>
              </div>
            </div>
          </div>
          <!-- 矛盾风险趋势 -->
          <div class="home-body-right-three home-box mt-14">
            <div class="home-box-title flex-between-center">
              <div class="flex-center">
                <img src="@/assets/image/arrow1.png" alt="" draggable="false">
                <span class="text font-bold">矛盾风险趋势</span>
              </div>
              <div class="flex-center">
                <img class="hover" src="@/assets/image/menu.png" alt="" draggable="false">
              </div>
            </div>
            <div class="home-box-content">
              <MaodunChart :dataList="chart_maodun"></MaodunChart>
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import QuanyuChart from '@/components/QuanyuChart'
import LaifangChart from '@/components/LaifangChart'
import ShouliChart from '@/components/ShouliChart'
import MaodunChart from '@/components/MaodunChart'
import { dashboard, selectWeather } from '@/api/screen'
//import axios from 'axios';
export default {
  name: "HomeView",
  components: { QuanyuChart, LaifangChart, ShouliChart, MaodunChart},
  data() {
    return {
      nowTime: '',
      weather_image: require('@/assets/weather/晴.png'),
      wendu: '20',
      classOption: {
        step: 0.2, // 数值越大速度滚动越快
        limitMoveNum: 5, // 开始无缝滚动的数据量 this.dataList.length
        hoverStop: true, // 是否开启鼠标悬停stop
        direction: 1, // 0向下 1向上 2向左 3向右
        openWatch: true, // 开启数据实时监控刷新dom
        singleHeight: 0, // 单步运动停止的高度(默认值0是无缝不停止的滚动) direction => 0/1
        singleWidth: 0, // 单步运动停止的宽度(默认值0是无缝不停止的滚动) direction => 2/3
        waitTime: 0, // 单步运动停止的时间(默认值1000ms)
      },
      classOption2: {
        step: 0.2, // 数值越大速度滚动越快
        limitMoveNum: 4, // 开始无缝滚动的数据量 this.dataList.length
        hoverStop: true, // 是否开启鼠标悬停stop
        direction: 2, // 0向下 1向上 2向左 3向右
        openWatch: true, // 开启数据实时监控刷新dom
        singleHeight: 0, // 单步运动停止的高度(默认值0是无缝不停止的滚动) direction => 0/1
        singleWidth: 0, // 单步运动停止的宽度(默认值0是无缝不停止的滚动) direction => 2/3
        waitTime: 0, // 单步运动停止的时间(默认值1000ms)
      },
      today: '',                //今日统计
      total: '',                //累计统计
      dept_list: [],            //大厅工作窗口
      feedback_list: [],        //群众意见箱
      visitor_list: [],         //窗口挂号
      visitor_joint_list: [],   //中心会诊
      chart_quanyu: [],         //全域态势感知
      chart_laifang: [],        //来访趋势分析
      chart_maodun: [],         //矛盾风险趋势
      chart_shouli: [],         //分中心受理情况
    }
  },
  mounted() {
    this.resize();
      window.onresize = function () {
      this.resize();
    }.bind(this);
    this.showTime();
    setInterval(() => {
      this.showTime();
    }, 1000)
    this.getData();
    setInterval(() => {
      this.getData();
    }, 20000)
    this.getWeather();
    setInterval(() => {
      this.getWeather();
    },21600000) //6h 21600000
  },
  methods: {
    getData(){
      dashboard().then(res => {
        this.today = res.data.today;
        this.total = res.data.total;
        this.dept_list = Object.values(res.data.dept_list);
        this.feedback_list = res.data.feedback_list;
        this.visitor_list = res.data.visitor_list;
        this.visitor_joint_list = res.data.visitor_joint_list;
        this.chart_quanyu = res.data.chart_quanyu;
        this.chart_laifang = res.data.chart_laifang;
        this.chart_maodun = res.data.chart_maodun;
        this.chart_shouli = res.data.chart_shouli;
      })
    },
    getWeather(){
      selectWeather().then(res => {
        this.wendu = res.data.data.wendu
        this.weather_image = require('@/assets/weather/' + res.data.data.forecast[0].type + '.png')
      })
      // axios.get('http://t.weather.sojson.com/api/weather/city/101181501')
      //   .then(response => {
      //     console.log(response.data)
      //   })
      //   .catch(error => {
      //     console.error("There was an error!", error);
      //   });
    },
    showTime() {
      const date = new Date();
      const year = date.getFullYear();
      const month = String(date.getMonth() + 1).padStart(2, '0'); // 月份从0开始，所以要加1
      const day = String(date.getDate()).padStart(2, '0');
      const hours = String(date.getHours()).padStart(2, '0');
      const minutes = String(date.getMinutes()).padStart(2, '0');
      const seconds = String(date.getSeconds()).padStart(2, '0');
      const weekday = ['星期日', '星期一', '星期二', '星期三', '星期四', '星期五', '星期六'][date.getDay()];
      this.nowTime = `${year}-${month}-${day} ${hours}:${minutes}:${seconds} ${weekday}`;
    },
    resize() {
      // 系统整体缩放
      let cliWidth = document.documentElement.clientWidth || document.body.clientWidth
      let contW = 1920
      let w = cliWidth / contW
      let homeDom = document.querySelector('#home-page');
      homeDom.style.transform = 'scale(' + w + ')';
    },
    toggleFullScreen(){
      const elem = document.documentElement;
      if (!document.fullscreenElement) { // 判断是否已经处于全屏状态，不是则进入全屏模式
        if (elem.requestFullscreen) { // 标准方法，适用于大多数浏览器（包括Chrome、Firefox等）
          elem.requestFullscreen();
        } else if (elem.mozRequestFullScreen) { // Firefox老版本API，已弃用，但仍需支持以防万一（moz前缀）
          elem.mozRequestFullScreen(); 
        } else if (elem.webkitRequestFullscreen) { // Chrome/Safari/Opera老版本API，已弃用，但仍需支持以防万一（webkit前缀） 
          elem.webkitRequestFullscreen(); 
        } else if (elem.msRequestFullscreen) { // IE/Edge API 
          elem.msRequestFullscreen(); 
        }
      } else { // 已经是全屏状态，则退出全屏模式 
        if (document.exitFullscreen) { 
          document.exitFullscreen(); 
        } else if (document.mozCancelFullScreen) { 
          document.mozCancelFullScreen(); 
        } else if (document.webkitExitFullscreen) { 
          document.webkitExitFullscreen(); 
        } else if (document.msExitFullscreen) { 
          document.msExitFullscreen(); 
        }
      } 
    },
    jump(url){
      this.$router.push({ path: url });
    }
  }
};
</script>
<style lang="scss" scoped>
  @import "~@/assets/css/echart.scss";
</style>